import PropTypes from 'prop-types'

const TermItem = ({ term, url }) => {
  return (
    <li className="heading-5 border-bottom no-padding margin-top-small">
      <a
        className="term-link color-text padding-small"
        href={ url }
        dangerouslySetInnerHTML={{ __html: term }} />
    </li>
  )
}

TermItem.propTypes = {
  term: PropTypes.string,
  url: PropTypes.string
}

export default TermItem
